import { DateTime } from 'luxon';

export default class VisitorPassEngine {

    validateVisitorPass(visitorPass, location) {
        let isCancelled = false,
            isExpired = false,
            notYetValid = false,
            isInvalidSite = false,
            isValid = false;

        if (visitorPass.cancelled) {
            isCancelled = true;
        }

        const startDate = DateTime.fromFormat(visitorPass.startDate, 'dd/MM/yyyy HH:mm');

        if (startDate.diffNow().as('seconds') > 0) {
            notYetValid = true;
        }

        const endDate = DateTime.fromFormat(visitorPass.endDate, 'dd/MM/yyyy HH:mm');

        if (endDate.diffNow().as('seconds') < 0) {
            isExpired = true;
        }

        if (visitorPass.siteID !== location.site.siteID) {
            isInvalidSite = true;
        }

        isValid = !isCancelled && !isExpired && !isInvalidSite && !notYetValid;

        return {
            pass: visitorPass,
            isCancelled,
            isExpired,
            notYetValid,
            isInvalidSite,
            isValid
        }
    }

    getVisitorPassStatus(enginePass) {
        let result = "",
            isWarning = false;

        if (enginePass.isInvalidSite) {
            result = "Invalid Site. ";
            isWarning = true;
        } else if (enginePass.isCancelled) {
            result = "Cancelled. ";
            isWarning = true;
        }
        else if (enginePass.notYetValid) {
            result = "Not Yet Valid. ";
            isWarning = true;
        }
        else if (enginePass.isExpired) {
            result = "Expired. ";
            isWarning = true;
        }

        if (enginePass.pass.swipedIn) {
            result += "Swiped In";
        }
        else if (enginePass.pass.swipedOut) {
            result += "Swiped Out";
        } else {
            result += "Pass Generated";
        }

        return {
            statusMessage: result,
            isWarning
        };
    }
}